import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { withStyles } from '@material-ui/core/styles';
import {
  Grid,
  Paper,
} from '@material-ui/core';
import { Logo, Toast } from '../../components/widgets';
import { LoginForm } from '../../components/forms';
import theme from '../../theme';

const LoginScreen = ({
  toastProps,
  formProps,
  classes,
}) => (
  <Fragment>
    <Toast {...toastProps} />
    <Grid container direction="column" alignItems="center">
      <Grid item>
        <LogoContainer>
          <Logo
            position="bottom"
            style={{
              fill: theme.palette.primary.main,
              size: 80,
            }}
          />
        </LogoContainer>
      </Grid>
      <Grid item>
        <Paper className={classes.paper}>
          <LoginForm {...formProps} />
        </Paper>
      </Grid>
    </Grid>
  </Fragment>
);

LoginScreen.propTypes = {
  formProps: PropTypes.object,
  toastProps: PropTypes.object,
  classes: PropTypes.object.isRequired,
};

LoginScreen.defaultProps = {
  formProps: {},
  toastProps: {},
};

const LogoContainer = styled.div`
  margin: 20px auto;
`;

export default withStyles({
  paper: {
    padding: `${theme.spacing.unit}px ${theme.spacing.unit * 20}px`,
  },
})(LoginScreen);
